import {
  styled,
  Typography,
} from '@mui/material';

export const Container = styled('div')(() => ({}));

export const InlineFieldContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  '& > div:nth-of-type(1)': {
    display: 'inline-block',
    width: '47%',
  },
  '& > div:nth-of-type(2)': {
    display: 'inline-block',
    width: '47%',
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    justifyContent: 'unset',
    '& > div': {
      width: '100% !important',
    }
  },
}));

export const FieldContainer = styled('div')(({ theme }) => ({
  marginBottom: 20,
  '&#noMarginField': {
    marginBottom: 10,
  },
  [theme.breakpoints.down('sm')]: {
    '&#noMarginField:first-of-type': {
      marginBottom: 20,
    },
  },
}));

export const IdText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
  marginTop: 23,
}));
